import { defineField, defineType } from 'sanity'
import { PageBlockTypes } from '../pageBlocks'

export default defineType({
  title: 'After Countdown Content',
  name: 'afterCountdown',
  type: 'object',
  fields: [
    defineField({
      title: 'Teaser Hero',
      name: 'hero',
      type: 'hero',
    }),
    defineField({
      title: 'Launch Youtube Video',
      name: 'launchVideo',
      type: 'string',
      description: 'This video will auto play.',
    }),
    defineField({
      title: 'Page blocks',
      name: 'pageBlocks',
      type: 'array',
      of: PageBlockTypes,
    }),
  ],
})